import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';

type PartnerSharesTableFooterProps = {
  sharesCountTotal: number;
};

const PartnerSharesTableFooter: FC<PartnerSharesTableFooterProps> = ({
  sharesCountTotal,
}: PartnerSharesTableFooterProps) => {
  const { t } = useTranslate();

  return (
    <tfoot>
      <tr>
        <td className="fw-bold">{t('Total')}</td>
        <td className="fw-bold text-right">{formatNumber(sharesCountTotal)}</td>
        <td className="" />
        <td className=" d-none d-md-table-cell" />
        <td className=" d-none d-md-table-cell" />
        <td className=" d-none d-md-table-cell" />
      </tr>
    </tfoot>
  );
};

export default PartnerSharesTableFooter;
